module.exports = __webpack_public_path__ + "static/6.2_kush_and_other_african_kingdoms-9139c487950dea74f3a611a75b86bba9.pdf";